module.exports = __webpack_public_path__ + "img/lemniscata_curve.9f034621.png";